// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_1u_Vn","center":"index-module_center_3p-TR","logo":"index-module_logo_2sLeE","logo-txt":"index-module_logo-txt_3cwl3"};